import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotate, faCircleExclamation, faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons';

export const OrderProduct = ({ item, orderId, supplier, isFetchable, index, checkAllProductsUpdated }) => {
    const [productData, setProductData] = useState(item);
    const [fetchStatus, setFetchStatus] = useState([faCircleExclamation, 'text-yellow-300']);
    const [loading, setLoading] = useState(false);

    const handleUpdateClick = async (e) => {
        e.stopPropagation();

        setLoading(true);
        try {
            const accessToken = localStorage.getItem('access_token');
            const response = await fetch(`${process.env.REACT_APP_API_URL}/products/${item.product.id}/fetch?orderId=${orderId}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                },
            });

            if (!response.ok) {
                setFetchStatus([faCircleXmark, 'text-red-300']);
                setLoading(false);

                throw new Error('Erro ao buscar os pedidos.');
            }

            const updatedData = await response.json();
            setProductData(updatedData.data);
            setLoading(false);

            setFetchStatus([faCircleCheck, 'text-green-300']);

            checkAllProductsUpdated(index);
        } catch (error) {
            console.error('Erro ao atualizar o produto:', error);
            setLoading(false);

            setFetchStatus([faCircleXmark, 'text-red-300']);
        }
    };

    return (
        <tr className="border-t">
            <td className="py-1.5 2xl:py-2 px-2 2xl:px-4 max-w-96">{productData.product.name}</td>
            <td className="py-1.5 2xl:py-2 px-2 2xl:px-4">{productData.product.supplier_code}</td>
            <td className="py-1.5 2xl:py-2 px-2 2xl:px-4">{productData.amount}</td>
            <td className="py-1.5 2xl:py-2 px-2 2xl:px-4">{supplier.name}</td>
            <td className="py-1.5 2xl:py-2 px-2 2xl:px-4 pr-0">
                <div className="relative flex items-center justify-between pr-0">
                    <span>{productData.formatted_unit_value}</span>
                    {isFetchable && (
                        <>
                            <div
                                className="bg-green-500 cursor-pointer text-white px-2 py-1 rounded ml-4 transition-all hover:bg-green-400 -translate-x-[10px]"
                                onClick={handleUpdateClick}
                            >
                                <FontAwesomeIcon icon={faRotate} className={`w-4 text-white text-center${loading && ' animate-spin'}`} />
                            </div>

                            <FontAwesomeIcon icon={fetchStatus[0]} className={`absolute -right-2 text-xs ${fetchStatus[1]}`} />
                        </>
                    )}
                </div>
            </td>
        </tr>
    );
};